import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from "../../hooks/hooks";
import Breadcrumbs from '../../components/Breadcrumbs';
import styles from './CmsHeader.module.scss'
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';

const CmsHeader: React.FC = () => {
    const userName = useAppSelector(state => state.Auth.user?.name || '');
    const clientName = useAppSelector(state => state.Auth.client?.name || '');

    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    return (
        <Grid columns="two" className={styles.grid}>
            <GridRow className={styles.row}>
                <GridColumn width="five" className={styles.column}>
                    <Breadcrumbs />
                </GridColumn>
                <GridColumn width="two" floated='right' textAlign='right'>
                    {userName}
                </GridColumn>
            </GridRow>
            <GridRow className={styles.row}>
                <GridColumn width="five" className={styles.column}>
                    {lastSegment.toUpperCase()}
                </GridColumn>
                <GridColumn width="two" floated='right' textAlign='right'>
                    {clientName}
                </GridColumn>
            </GridRow>
        </Grid>
    );
}

export default CmsHeader;
